import { render } from "./BattlesHeaderCreate.vue?vue&type=template&id=15d7ad69&scoped=true"
import script from "./BattlesHeaderCreate.vue?vue&type=script&lang=js"
export * from "./BattlesHeaderCreate.vue?vue&type=script&lang=js"

import "./BattlesHeaderCreate.vue?vue&type=style&index=0&id=15d7ad69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d7ad69"]])

export default __exports__